import { isAnnual } from "@/react/helpers/planHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import {
  hasCurrentPlanAnAlternativePlan,
  planIntervals,
} from "@circle-react/helpers/plansHelpers";
import type { PlanIntervals } from "@circle-react/helpers/plansHelpers";
import { usePlans } from "../components/SettingsApp/Plan/RegularPlan/PlansContext";
import { useQueryParamChange } from "./useQueryParamChange";

export const useBillingCycleState = () => {
  const { billingCycle, currentPlan } = usePlans();
  const { currentCommunity } = usePunditUserContext();
  const handleQueryParamChange = useQueryParamChange();

  const isYearly = (() => {
    if (!billingCycle && currentPlan) {
      return !currentCommunity?.is_on_trial;
    }
    return isAnnual(billingCycle);
  })();

  const shouldShowBillingCycleOptions =
    hasCurrentPlanAnAlternativePlan(currentPlan);

  const isSelected = (planInterval: PlanIntervals): boolean => {
    if (!billingCycle && currentPlan) {
      return planInterval === planIntervals.year
        ? !currentCommunity?.is_on_trial
        : !!currentCommunity?.is_on_trial;
    }
    return billingCycle === planInterval;
  };

  const handleIntervalChange = (interval: string) => {
    handleQueryParamChange("billing_cycle", interval);
  };

  const handleToggle = (checked: boolean) => {
    const newInterval = checked ? planIntervals.year : planIntervals.month;
    handleQueryParamChange("billing_cycle", newInterval);
  };

  return {
    billingCycle,
    currentPlan,
    isYearly,
    shouldShowBillingCycleOptions,
    isSelected,
    handleIntervalChange,
    handleToggle,
    planIntervals,
  };
};
